import { useEffect, useState } from 'react'
import { TOAST_TIMER } from '../constants';

export const useToastInfo = () => {
  const [toastInfo, setToastInfo] = useState(null);
  const { autoExpire } = toastInfo || {};
  useEffect(() => {
    let toastTimer = null;
    if (autoExpire) {
      toastTimer = setTimeout(() => {
        setToastInfo(null);
      }, TOAST_TIMER)
    }
    return () => {
      clearTimeout(toastTimer);
    }
  }, [autoExpire])

  return {
    toastInfo, setToastInfo
  }
}
